import { z as zod } from 'zod';

import { BaseDtoSchema } from '@enterprise/types';

import { TagCategorySchema } from './tag-category.schema';

/**
 * Zod schema for a Tag object.
 *
 * Extends the BaseDtoSchema and adds the following properties:
 * - `category`: An optional tag category, validated by TagCategorySchema.
 * - `label`: An string label for the tag.
 */
export const TagSchema = BaseDtoSchema.extend({
  category: TagCategorySchema.optional(),
  label: zod.string(),
});
